import 'config/chat';
import 'config/dayjs';
import 'config/yupLocale';
import 'react-toastify/dist/ReactToastify.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'styles/global.css';
import 'styles/tailwind.css';
import 'v2/services/eduzzAccount';
import './hotjar';

import { createRoot } from 'react-dom/client';
import { ensureRemoteThemeCache } from 'v2/helpers/remoteTheme';

import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { IS_PROD } from './settings';

ensureRemoteThemeCache();

const root = createRoot(document.getElementById('app') as HTMLElement);
root.render(<App />);

if (!IS_PROD) {
  reportWebVitals();
}
